<template>
    <div class="banner-item">
        <a v-if="hasHttp(target)" :href="target" target="_blank">
            <img :src="src_url + '/' + src + '/' + file_name" :alt="name" :title="name" class="img-fluid" />
        </a>
        <router-link v-else :to="{ path: target}">
            <img :src="src_url + '/' + src + '/' + file_name" :alt="name" :title="name" class="img-fluid" />
        </router-link>
    </div>
</template>

<script>
export default {
    props: ['name', 'target', 'src', 'file_name' ],
    data(){
        return{
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    }
}
</script>